import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Ĉiumatene la Ŝutro per vasta gesto malfermas la fenestron:
    </p>
    
    <p class="mb-3">
      - Ekstere la tuta lumo estas nia, ni prenu kiom eblas!
    </p>
    
    <p class="mb-3">
      Kaj ĉiuvespere la Ŝutro firme fermas la fenestron:
    </p>
    
    <p class="mb-3">
      - La tuta lumo en la ĉambro estas nia, ni gardu ĝin de fremduloj!
    </p>
    `
  )
}

const itemName = {
  esp: 'La ŝutro'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;